// The master fetch api! All fetch calls flow through here

// These headers are consistent for all of our calls
const baseHeaders = { 'X-Requested-With': 'Fetch' };

// The key in a 200 response that determines if the API operation succeeded. We use this in the majority of our backend Resources
// IE11 fun - all our calls have an appended random number to bust shitty caching
const cacheBustPath = (url) => `${url}?v=${Math.random() * 10000}`;

// The key in a 200 response that determines if the API operation succeeded.
const successfulFlag = 'successful';

const errorTitle = 'Sorry, something went wrong.';
const errorMessage = 'We are currently experiencing technical issues. Please try again later.';

/**
 * Routes the response to either the success or error handlers.
 */
const checkStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    // The raw response before parseJSON(response)
    return response;
  }

  // An unexpected error occurred not from the API. An example of this is a 502 error.
  throw response;
};

/**
 * In this case, the 'success: false' flag from the backend API is handled.
 */
const checkApiStatus = (response) => {
  if (successfulFlag in response && !response[successfulFlag]) {
    throw response;
  }

  return response;
};


/**
 * Handles the error callback in a consistently formatted manner.
 */
const handleError = (response, errorCallback) => {
  if (errorCallback) {
    errorCallback({
      name: response.status,
      message: {
        title : errorTitle,
        body: response.error && response.error.message ?  response.error.message : errorMessage,
      }
    });
  }
};

/**
 * Handles the success callback. All success responses are formatted in a similar way from the API.
 */
const handleSuccess = (response, successCallback) => {
  if (successCallback) {
    successCallback(response);
  }
};

/**
 * All of the API responses are JSON formatted.
 */
const parseJSON = (response) => response.json();

const getApi = (url, headers, successCallback, errorCallback) => {
  const cacheBustedUrl = cacheBustPath(url);

  return fetch(cacheBustedUrl, {
    headers: {
      ...baseHeaders,
      ...headers
    },
    method: 'GET',
    credentials: 'include',
  }).then(checkStatus)
    .then(parseJSON)
    .then(checkApiStatus)
    .then(response => handleSuccess(response, successCallback))
    .catch(error => handleError(error, errorCallback));
};

const postApi = (url, headers, data, successCallback, errorCallback) => {
  const cacheBustedUrl = cacheBustPath(url);

  return fetch(cacheBustedUrl, {
    headers: {
      ...baseHeaders,
      ...headers
    },
    method: 'POST',
    body: data,
    credentials: 'include',
  }).then(checkStatus)
    .then(parseJSON)
    .then(checkApiStatus)
    .then(response => handleSuccess(response, successCallback))
    .catch(error => handleError(error, errorCallback));
};

const postApiWithNoDataParam = (url, headers, successCallback, errorCallback) => {
  const cacheBustedUrl = cacheBustPath(url);

  return fetch(cacheBustedUrl, {
    headers: {
      ...baseHeaders,
      ...headers
    },
    method: 'POST',
    credentials: 'include',
  }).then(checkStatus)
    .then(parseJSON)
    .then(checkApiStatus)
    .then(response => handleSuccess(response, successCallback))
    .catch(error => handleError(error, errorCallback));
};

const deleteApi = (url, headers, data, successCallback, errorCallback) => {
  const cacheBustedUrl = cacheBustPath(url);

  return fetch(cacheBustedUrl, {
    headers: {
      ...baseHeaders,
      ...headers
    },
    method: 'DELETE',
    body: data,
    credentials: 'include',
  }).then(checkStatus)
    .then(parseJSON)
    .then(checkApiStatus)
    .then(response => handleSuccess(response, successCallback))
    .catch(error => handleError(error, errorCallback));
};

const UpdoxApi = {
  getApi,
  postApi,
  postApiWithNoDataParam,
  deleteApi,
};

export default UpdoxApi;



// WEBPACK FOOTER //
// ./src/apis/updoxapi.js